<template>
  <el-dialog v-loading="isLoading" :title="title" append-to-body :visible.sync="mIsShow">

    <el-form :model="form" label-width="100px" @submit.native.prevent style="max-width: 1030px;">
      <el-form-item label="金額">
        <el-input v-model="form.Amount"></el-input>
      </el-form-item>
      <el-form-item label="使用期限">
        <el-date-picker
          v-model="form.Deadline"
          type="date"
          placeholder="使用期限"
          value-format="yyyy-MM-dd"
          class="w-100"
          style="width: 100%;">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="管理員備註">
        <el-input v-model="form.AdminRemark"></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="submit">送出</el-button>
    </div>
  </el-dialog>
</template>

<script>
import MixinOfPreventLeaveEditPage from '@/utils/mixin-prevent-leave.vue'
export default {
  mixins: [MixinOfPreventLeaveEditPage],
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    oriObj: {
      default: () => {
        return null
      }
    },
    userID: {
      type: Number
    }
  },
  data () {
    return {
      form: {
        Amount: 0
      },
      mIsShow: false,
      isLoading: false
    }
  },
  computed: {
    user () {
      return this.$store.state.user.list.find(o => o.ID === this.userID) || { Profile: {} }
    },
    isEdit () {
      return false
    },
    title () {
      return `新增購物金 -> ${this.user.Profile.Name}`
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    submit () {
      if (!this.validateInput()) {
        return
      }
      let payload = JSON.parse(JSON.stringify(this.form))
      payload.Amount = parseInt(payload.Amount) || 0
      payload.UserID = this.userID
      if (payload.Deadline.length === 10) payload.Deadline += 'T23:59:59+08:00'

      if (this.isEdit) throw String('unexpected edit voucher in [modal-addedit-voucher]')
      let promise = this.isEdit
        ? this.$services.userGiftVoucher.edit(this, payload)
        : this.$services.userGiftVoucher.add(this, payload)
      promise.then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (ok) this.onObjAddedit(res, payload)
      }).catch(this.$handleServiceError)
    },
    onObjAddedit (res, payload) {
      this.isSubmitted = true
      this.loadResult(res)
      this.$message({
        message: `${this.isEdit ? '修改' : '新增'}成功`,
        type: 'success'
      })
      this.form = { Profile: {} }
      // this.$emit('submitted', payload)
      this.$emit('submitted', res.data.result)
      this.close()
    },
    loadResult (res) {
      // var newObj = JSON.parse(JSON.stringify(this.form.Profile))
      // if (!this.isEdit) {
      //   this.$store.state.user.list.splice(0, 0, newObj)
      // } else {
      //   let oldProfile = JSON.parse(JSON.stringify(this.oriObj.Profile))
      //   let newProfile = Object.assign(oldProfile, newObj)
      //   let idx = this.$store.state.user.list.findIndex(
      //     o => o.ID === this.userID
      //   )
      //   if (idx >= 0) {
      //     this.$set(this.$store.state.user.list[idx], 'Profile', newProfile)
      //   } else {
      //     console.error(`unknown user for id ${this.userID}`)
      //   }
      // }
    },
    validateInput () {
      var errMsg = null

      let amount = parseInt(this.form.Amount)
      if (typeof amount !== 'number') errMsg = '請輸入數字'
      else if (amount <= 0) errMsg = '請輸入大於0的數字'
      else if (amount > 0 && !this.form.Deadline) errMsg = '請輸入有效期限'
      // if (!this.form.TitleTw) {
      //   errMsg = '請輸入繁中標籤'
      // }
      if (errMsg) {
        this.$alert(errMsg, '錯誤', {
          confirmButtonText: '確認',
          type: 'error'
        })
      }
      return errMsg === null
    }
  },
  created () {
    this.mIsShow = this.isShow
  },
  watch: {
    isShow () {
      this.mIsShow = this.isShow
    },
    mIsShow () {
      if (!this.mIsShow) this.close()
      else {
        if (this.oriObj) {
          this.form = { Profile: JSON.parse(JSON.stringify(this.oriObj.Profile)) }
        } else {
          this.form = {
            Profile: {}
          }
        }
      }
    }
  }
}
</script>
